import { getters } from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  meetings: [],
  meeting: null,
  agenda: null,
  uiFlags: {
    isLoading: false,
    isSaving: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
